import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { ROUTES } from '@/app/routes';
import { ModerationRulesPanel } from '../components/ModerationRulesPanel';
import { PolicyConfidenceThresholdsPanel } from '../components/PolicyConfidenceThresholdsPanel';
import { ModerationToolLinks } from '../components/ModerationToolLinks';

export function ModerationRulesPage() {
  return (
    <div className="flex flex-col gap-4 p-6">
      <nav className="flex items-center gap-1 text-sm text-muted-foreground">
        <Link to={ROUTES.moderation} className="hover:text-foreground">
          Moderation
        </Link>
        <ChevronRight className="size-4" />
        <span className="text-foreground">Rules</span>
      </nav>

      <ModerationToolLinks compact />

      <ModerationRulesPanel />

      <PolicyConfidenceThresholdsPanel />
    </div>
  );
}
